// extracted by extract-css-chunks-webpack-plugin
module.exports = {"module":"module__module--1wzvK","with-footer":"module__with-footer--gxZx_","withFooter":"module__with-footer--gxZx_","xs":"module__xs--3AZVr"};